import {Component, OnInit} from '@angular/core';
import {AppComponent} from './app.component';
import { ConfirmationService } from 'primeng/primeng';
import { Constantes } from './domain/constantes';
import { AuthenticationService } from './providers/authentication/authentication.service';
import { Router } from '@angular/router';
import {TranslatePipe, TranslateService, LangChangeEvent} from 'ng2-translate';
import {getEntidad } from './app.module'
import { isString } from 'util';
import { ServiciosWebServiceProvider } from './providers/web-service-service/servicios-web-service';
@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
	providers: [ConfirmationService]
})
export class AppTopBarComponent {

	userName;
	logo: string = Constantes.LOGO_TOPBAR;
	colorTopBar: string = Constantes.COLOR_TOPBAR;

    constructor(
		public app: AppComponent,
		public authService: AuthenticationService,
		private router: Router,
		private confirmationService: ConfirmationService,
		private translate: TranslateService,
		private sws: ServiciosWebServiceProvider
	){

		this.userName = this.authService.getLastUser();

	}


	logout() {
		console.log('***** LOGOUT ******');
		this.confirmationService.confirm({
			message: this.translate.instant('MensajesConfirmacion.MENSAJE_LOGOUT'),
			header: this.translate.instant('MensajesConfirmacion.MENSAJE_CABECERA_CONFIRMACION'),
			icon: 'fa fa-question-circle',
			accept: () => {
				this.authService.logout();
				this.router.navigate(['/']);
			},
			reject: () => {

			}
		});
	}

	settings(){
		this.router.navigate(['/entidades']);
	}

	ngOnInit() {
		const entidad = getEntidad();
		const that = this;
		console.log(entidad);
		// TODO: TENEMOS QUE COMPROBAR SI EXISTE UNA CARPETA CON EL NOMBRE ENTIDAD DENTRO DE IMAGES, SI NO EXISTE DEBEREMOS IGUALAR LA VARIABLE ENTIDAD A CADENA VACIA
		this.sws.getLogoPath(entidad).toPromise()
		.then(function (data) {
			console.log(data);
			that.logo = data;
		})
		.catch(function (error) {
			console.log("ERROR:" + error);
		});
		// this.logo = "assets/itsoft/images/"+entidad+"ITSN.png"
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/app.topbar.component.ts